var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_62",
    "data-name": "Mask Group 62",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(254.523 10.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M13.762.476a4.664,4.664,0,0,0-2.033.495l.425.847a3.726,3.726,0,0,1,1.619-.394Zm.727.048-.135.938a3.733,3.733,0,0,1,1.554.6l.532-.784a4.669,4.669,0,0,0-1.95-.757Zm-3.64,1.019C10.29,2,9.922,2.533,9.5,2.865l.587.744c.57-.451.94-.988,1.36-1.331Zm6.389.422-.694.646a3.656,3.656,0,0,1,.821,1.445l.909-.269A4.592,4.592,0,0,0,17.238,1.966ZM8.79,3.572,7.45,4.912l.67.67,1.34-1.34Zm9.67,1.249-.946.064a3.811,3.811,0,0,1-.254,1.651l.881.348a4.747,4.747,0,0,0,.318-2.064ZM6.78,5.582,5.44,6.922l.67.67,1.34-1.34ZM16.866,7.275a3.576,3.576,0,0,1-.416.5h0l-.82.82.67.67.819-.819h0a4.517,4.517,0,0,0,.526-.63Zm-12.1.317L3.43,8.932l.67.67,1.34-1.34ZM14.96,9.264,13.62,10.6l.67.67,1.34-1.34ZM2.759,9.6l-.926.926a4.556,4.556,0,0,0-.427.493l.759.567A3.609,3.609,0,0,1,2.5,11.2l.927-.926Zm10.19,1.672-1.34,1.34.67.67,1.34-1.34ZM.876,11.933a4.736,4.736,0,0,0-.392,2.052l.947-.031a3.8,3.8,0,0,1,.312-1.641ZM10.94,13.284,9.6,14.625l.67.67,1.34-1.34Zm-9.389,1.5-.918.236A4.6,4.6,0,0,0,1.6,16.881l.717-.619a3.668,3.668,0,0,1-.768-1.475Zm7.438.457a14.265,14.265,0,0,0-1.383,1.365l.626.711c.54-.476.887-1,1.308-1.3ZM2.935,16.829l-.558.766a4.642,4.642,0,0,0,1.929.815l.163-.934a3.706,3.706,0,0,1-1.534-.647Zm3.984.26a3.768,3.768,0,0,1-1.609.441l.043.947a4.7,4.7,0,0,0,2.016-.554Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M4.57,14.383,14.383,4.57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M14.377,4.1a.474.474,0,0,0-.329.139L4.235,14.048a.474.474,0,0,0,.67.67l9.812-9.812a.474.474,0,0,0-.341-.809Z",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.e7afbeee24c194077d924f3ba3be55e4.svg";
export { ForwardRef as ReactComponent };